/**
 * Эффективно просмотренное множество шагов (ТЗ §12.1, T-19).
 *
 * Локальный кеш и серверное состояние объединяются теми же правилами, что и на сервере
 * (M-1): при совпадении `stepId` побеждает бо́льший `rev`, при равном `rev` — более
 * поздний `at`. Иначе вкладка, не успевшая отправить прогресс, показала бы шаг заново.
 */

import type { SeenStep } from '../types';

export type EffectiveSeen = ReadonlyMap<string, SeenStep>;

function wins(candidate: SeenStep, current: SeenStep): boolean {
  if (candidate.rev !== current.rev) return candidate.rev > current.rev;
  return Date.parse(candidate.at) >= Date.parse(current.at);
}

export function mergeSeenSteps(...sources: readonly (readonly SeenStep[] | undefined)[]): SeenStep[] {
  const merged = new Map<string, SeenStep>();
  for (const source of sources) {
    for (const step of source ?? []) {
      const current = merged.get(step.id);
      if (!current || wins(step, current)) merged.set(step.id, step);
    }
  }
  return [...merged.values()];
}

export function effectiveSeen(...sources: readonly (readonly SeenStep[] | undefined)[]): EffectiveSeen {
  return new Map(mergeSeenSteps(...sources).map((step) => [step.id, step]));
}
